/**
 * Whether a config-authored HTML string has anything the applicant would see.
 *
 * The settings rich-text editor exports `editor.getHTML()`, which returns
 * markup like "<p></p>" for an emptied field rather than "". A plain
 * truthiness check reads that as filled, so callers gating on it render an
 * empty element and its spacing. Strip tags and entities before deciding.
 */
const hasVisibleContent = (value?: string): value is string => {
  // Values are read from a JSON column, so the declared type is not enforced
  // at runtime.
  if (typeof value !== "string") {
    return false;
  }

  return (
    value
      .replace(/<[^>]+>/g, " ")
      .replace(/&nbsp;/gi, " ")
      .trim() !== ""
  );
};

export default hasVisibleContent;
